import { Component, Inject} from '@angular/core';
import { ValueFormatter, KnownFlagEnums, flagEnumOptions } from '../../../../../../../../../../../common/components/data-table/formatters/data-table.formatters';
import { AbstractControl} from '@angular/forms';
import { DATA_TOKEN } from '../../../../grid-option-config/tokens';
import { AgentType } from '../../../../../../../../../../../admin/models/contact.model';
import { WellPermittingModifiers } from '../../../../../../../../../../../common/models/well.model';

const StringIsNotANumber = value => isNaN(Number(value)) === true;

@Component({
    selector: 'flagEnum-options',
    templateUrl: './flagEnum-options.component.html',
    standalone: false
})

export class FlagEnumOptionsComponent {

    formControl: AbstractControl;
    types = ValueFormatter;
    flagEnumTypes = Object.values(KnownFlagEnums);
    selectedflagEnumTypes: any[];
    options: flagEnumOptions = {
        enumObject: AgentType,
        selectedFlagEnum: KnownFlagEnums.AgentType,
        selectedFlagEnumValue: "None"
    };


    constructor(
        @Inject(DATA_TOKEN) public data: AbstractControl
    ) {
        this.formControl = this.data;

        if (this.formControl.value) {
            this.options = this.formControl.value;
        }


        this.updateSelectedFlagEnumValues()
    }

    ngAfterViewInit() {
    }

    selectedFlagEnumChangeHandler(event: any) {
            this.updateSelectedFlagEnumValues();
    }

    selectedFlagEnumValueChangeHandler(event: any) {
        this.formControl.setValue(this.options);
    }

    updateSelectedFlagEnumValues() {

        switch (this.options.selectedFlagEnum) {
            case KnownFlagEnums.AgentType: {
                this.options.enumObject = AgentType;
                this.selectedflagEnumTypes = Object.values(AgentType).filter(StringIsNotANumber);
                break;
            }
            case KnownFlagEnums.WellPermittingModifiers: {
                this.options.enumObject = WellPermittingModifiers;
                this.selectedflagEnumTypes = Object.values(WellPermittingModifiers).filter(StringIsNotANumber);
                break;
            }
        }
        this.formControl.setValue(this.options);
    }
}

